import { createContext } from "react";
import { AuthSessionState } from "../data/authSessionState";

export const AuthSessionContext = createContext<AuthSessionState>({} as AuthSessionState);